import { useState, useMemo } from "react";
import { Reveal } from "@/components/Reveal";
import { UNITS } from "@/data/units";

export default function Gallery() {
  const { areas, imagesByArea } = useMemo(() => {
    const map = {};
    UNITS.forEach((u) => {
      map[u.area] = map[u.area] || [];
      u.gallery.forEach((src) => map[u.area].push({ src, area: u.area, name: u.name }));
    });
    return { areas: Object.keys(map), imagesByArea: map };
  }, []);

  const [active, setActive] = useState("All");
  const categories = ["All", ...areas];

  const images =
    active === "All"
      ? Object.values(imagesByArea).flat()
      : imagesByArea[active] || [];

  return (
    <section data-testid="gallery-page" className="px-6 md:px-12 pt-36 md:pt-40 pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto">
        <Reveal className="max-w-3xl">
          <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">Gallery</span>
          <h1 className="mt-5 text-5xl sm:text-6xl tracking-tighter font-light leading-none text-[#1C1917]">A look inside</h1>
          <p className="mt-8 text-lg text-[#44403C] leading-relaxed font-light">
            Real photos of our furnished rooms and shared spaces across the Austin area.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap gap-3" role="tablist">
            {categories.map((cat) => (
              <button
                key={cat}
                data-testid={`gallery-filter-${cat.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                onClick={() => setActive(cat)}
                className={`rounded-full px-5 py-2.5 text-sm transition-colors duration-300 border ${
                  active === cat
                    ? "bg-[#1C1917] text-white border-[#1C1917]"
                    : "bg-transparent text-[#44403C] border-[#E7E5E4] hover:bg-[#F5F5F4]"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-14 columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
          {images.map((item, i) => (
            <Reveal key={`${item.src}-${i}`} delay={(i % 3) * 0.05} y={16} className="mb-4 break-inside-avoid">
              <div className="rounded-2xl overflow-hidden border border-[#E7E5E4] group" data-testid={`gallery-image-${i}`}>
                <img
                  src={item.src}
                  alt={`${item.name} — ${item.area} — Masaya Hospitality`}
                  loading="lazy"
                  className="w-full h-auto object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
